import React from "react";
import { FaUserCircle } from "react-icons/fa";

const commentsData = [
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [
                      {
                        name: "Satyam Srivastava",
                        text: "Lorem ipsum dolor sit amet,consectetur adip",
                        replies: [],
                      },
                    ],
                  },
                ],
              },
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [],
                  },
                ],
              },
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
            ],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [],
                  },
                ],
              },
            ],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [
                      {
                        name: "Satyam Srivastava",
                        text: "Lorem ipsum dolor sit amet,consectetur adip",
                        replies: [
                          {
                            name: "Satyam Srivastava",
                            text: "Lorem ipsum dolor sit amet,consectetur adip",
                            replies: [],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
        ],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
            ],
          },
        ],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
        ],
      },
    ],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [
                      {
                        name: "Satyam Srivastava",
                        text: "Lorem ipsum dolor sit amet,consectetur adip",
                        replies: [],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
            ],
          },
        ],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [],
      },
    ],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [],
      },
    ],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
        ],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
        ],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [],
                  },
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [
                      {
                        name: "Satyam Srivastava",
                        text: "Lorem ipsum dolor sit amet,consectetur adip",
                        replies: [],
                      },
                    ],
                  },
                  {
                    name: "Satyam Srivastava",
                    text: "Lorem ipsum dolor sit amet,consectetur adip",
                    replies: [],
                  },
                ],
              },
              {
                name: "Satyam Srivastava",
                text: "Lorem ipsum dolor sit amet,consectetur adip",
                replies: [],
              },
            ],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
          {
            name: "Satyam Srivastava",
            text: "Lorem ipsum dolor sit amet,consectetur adip",
            replies: [],
          },
        ],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [],
      },
      {
        name: "Satyam Srivastava",
        text: "Lorem ipsum dolor sit amet,consectetur adip",
        replies: [],
      },
    ],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [],
  },
  {
    name: "Satyam Srivastava",
    text: "Lorem ipsum dolor sit amet,consectetur adip",
    replies: [],
  },
];

const Comment = ({ data }) => {
  const { name, text, replies } = data;

  return (
    <div className="flex flex-row pt-2 my-2 shadow-lg bg-gray-200">
      <div className="ml-7">
        <FaUserCircle size={25} color={"#ff0000"} />
      </div>
      <div className="px-3">
        <p className="font-bold">{name}</p>
        <p>{text}</p>
      </div>
    </div>
  );
};

const CommentsList = ({ comments }) => {
  return comments.map((comment, index) => (
    <div>
      <Comment key={index} data={comment} />
      <div className="pl-5 border border-l-black ml-10">
        <CommentsList comments={comment.replies} />
      </div>
    </div>
  ));
};

const CommentsContainer = () => {
  return (
    <div>
      <p className="text-2xl font-bold mx-7">Comments:</p>
      <CommentsList comments={commentsData} />
    </div>
  );
};

export default CommentsContainer;
